"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var _Transition = require("react-transition-group/Transition");

const getOpacity = transitionState => {
  switch (transitionState) {
    case 'entered':
      return 1;

    default:
      return 0;
  }
};

const container = ({
  cssProps
}) => ({
  transition: "opacity ".concat(cssProps.duration, "ms ease-in-out"),
  animationDelay: "".concat(cssProps.timeout, "ms"),
  opacity: getOpacity(cssProps.transitionState),
  width: '100%',
  height: '100%'
});

exports.container = container;
//# sourceMappingURL=ContentFadeIn.style.js.map